import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

type Props = {
	name: string;
	description: string;
	color: string;
};

const ChartLegendItem = (props: Props) => (
	<ChartLegendItemContainer>
		<ChartLegendItemBox>
			<ChartLegendItemLine color={props.color} />
		</ChartLegendItemBox>

		<ChartLegendItemText>
			<ChartLegendItemName>{props.name}</ChartLegendItemName>
			<ChartLegendItemDescription>{props.description}</ChartLegendItemDescription>
		</ChartLegendItemText>
	</ChartLegendItemContainer>
);

export default ChartLegendItem;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLegendItemContainer = styled.div({
	display: 'flex',
	marginRight: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:nth-last-child(1)': {
		marginRight: 0,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLegendItemBox = styled.div({
	display: 'flex',
	borderRadius: '3px',
	alignItems: 'center',
	justifyContent: 'center',
	height: '30px',
	width: '30px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLegendItemLine = styled.div<{ color: string }>({
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props: any) => props.color,
	height: '3px',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLegendItemText = styled.div({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	marginLeft: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLegendItemName = styled.h5({
	fontWeight: 500,
	fontSize: token('font.body'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLegendItemDescription = styled.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.DN100),
	font: token('font.body.small'),
	fontWeight: 300,
	marginTop: token('space.025', '2px'),
});
